<template>
	<main class="mb-6">
		<h6 class="text-white mb-2">Saldo Saya</h6>
		<h3 class="text-white">
			<strong>Rp {{ formatRupiah( data.balance ) }},</strong>
		</h3>
	</main>
</template>
<script>
	export default {
		data: () => ({
			data: {
				balance: 0
			}
		}),
		created() {
			this.$store.dispatch('user/getBalance', 0)
			.then(balance => {
				this.data.balance = balance
			})
			.catch(e => {
				this.showError(e)
				return false
			})
		}
	}
</script>